import React, { useState, useEffect } from 'react';
import {
  Alert,
  Container,
  Grid,
  Snackbar,
} from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ArrowBack } from '@mui/icons-material';
import Images from '../../../../Configs/images';
import ROUTES from '../../../../Configs/routes';
import { resendLink } from '../../../../Redux/Models/auth';

export default function SignupConfirmation({ classes, regisSuccess }) {
  // const navigate = useNavigate();
  const dispatch = useDispatch();

  const [submitted, setSubmitted] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const closeSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const location = useLocation();

  useEffect(() => {
    if (regisSuccess && submitted) {
      setSnackbar({
        open: true,
        message: 'Success resend email confirmation link. Please check your email!',
        severity: 'success',
      });
    }
  }, [regisSuccess, submitted]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    if (location.state) {
      dispatch(resendLink(location.state));
    } else {
      setSnackbar({
        open: true,
        message: 'No signup session found',
        severity: 'error',
      });
    }
  };

  return (
    <div className={classes.root}>
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackbar.open} autoHideDuration={10000} onClose={closeSnackbar}>
        <Alert onClose={closeSnackbar} severity={snackbar.severity || 'success'}>
          {snackbar.message}
        </Alert>
      </Snackbar>
      <Grid container spacing={0} justifyContent="center">
        <Grid item xs={12} sm={10} md={6} lg={4}>
          <Container sx={{ py: 5, minHeight: '100vh', position: 'relative' }} maxWidth="sm">
            <div className="center">
              <h1>
                <img src={Images.Logo} alt="Boxpack" height={65} />
              </h1>
              <img src={Images.Inbox} alt="Inbox" className="mt-5" />
              <h3 className="mt-6 s-16">Email confirmation</h3>

              <div className="height-14 mt-1 desc center">
                Thank you for signing up!
                <br />
                we sent verification link to
                <br />
                <div className="weight-600">{location.state?.email}</div>
              </div>
            </div>

            {/* <div className="action">
              <Container sx={{ pb: 4 }}>
                <div>
                  <Button
                  size="large"
                  onClick={() => navigate(ROUTES.signin())}
                  variant="contained"
                  className="btn-contained"
                  fullWidth>
                  Back to sign in
                  </Button>
                </div>

                <div className="center mt-5">
                  <div>
                    Didn&apos;t recieve email? Check your spam filter or
                    {' '}
                    <strong className="link" onClick={handleSubmit}>Resend</strong>
                  </div>
                </div>
              </Container>
            </div> */}

            <div className="center mt-5">
              <div className="height-14 weight-600">
                Didn&apos;t receive email?
                {' '}
                <span onClick={handleSubmit} className="link primary-green weight-700">resend</span>
              </div>
            </div>

            <div className="center mt-4 align-items-center flex-center flex">
              <ArrowBack fontSize="small" />
              <Link to={ROUTES.signin()} className="s-14 link black weight-600">Back to Sign in</Link>
            </div>

          </Container>
        </Grid>
      </Grid>
    </div>
  );
}
